<template>
    <v-overlay
        :model-value="modelValue"
        class="app-logo-loader-overlay align-center justify-center"
        color="black"
        opacity="0.2"
        :persistent="persistent"
        :close-on-back="false"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <img
            src="/img/icons/pwa-192x192.png"
            alt=""
            width="128"
            height="128"
            class="app-logo-loader-overlay__spinner"
            aria-hidden="true"
        />
    </v-overlay>
</template>

<script setup lang="ts">
// 1. Imports
// (none)

// 2. Props / Emits
withDefaults(
    defineProps<{
        modelValue: boolean
        persistent?: boolean
    }>(),
    {
        persistent: false
    }
)

defineEmits<{
    'update:modelValue': [value: boolean]
}>()
</script>

<style lang="scss" scoped>
@keyframes app-logo-loader-rotate {
    0% {
        transform: rotate(0deg);
        animation-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);
    }

    50% {
        transform: rotate(180deg);
        animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    100% {
        transform: rotate(360deg);
    }
}

.app-logo-loader-overlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .app-logo-loader-overlay__spinner {
        animation: app-logo-loader-rotate 1.5s infinite linear;
        will-change: transform;
    }
}
</style>
